import { render, staticRenderFns } from "./Analytics.vue?vue&type=template&id=52b08672"
import script from "./Analytics.vue?vue&type=script&lang=js"
export * from "./Analytics.vue?vue&type=script&lang=js"
import style0 from "./Analytics.vue?vue&type=style&index=0&id=52b08672&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports